import {isoDateUtcSchema} from 'common/src/modules/shared/copilot/copilot.schemas';
import {z} from 'zod';

const campaignAnalyticsPerformingInputSchema = z.object({
  dimension: z.string().describe('The viewing dimension'),
  metrics: z
    .array(z.string())
    .describe('The Requested metrics. Must be taken from the "Available metrics" list'),
  startDate: isoDateUtcSchema.describe('Requested start date (start of the day)'),
  endDate: isoDateUtcSchema.describe('Requested end date (end of the day)'),
  count: z.number().describe('The number of results to return').nullable().optional(),
  filter: z
    .object({
      dimension: z.string().describe('The filtering dimension'),
      values: z.array(z.string()),
    })
    .nullable()
    .optional(),
});

export {campaignAnalyticsPerformingInputSchema};
